import(/* webpackMode: "eager" */ "/app/assets/policy/pic1.png");
;
import(/* webpackMode: "eager" */ "/app/assets/policy/pic10.png");
;
import(/* webpackMode: "eager" */ "/app/assets/policy/pic11.png");
;
import(/* webpackMode: "eager" */ "/app/assets/policy/pic12.png");
;
import(/* webpackMode: "eager" */ "/app/assets/policy/pic13.png");
;
import(/* webpackMode: "eager" */ "/app/assets/policy/pic14.png");
;
import(/* webpackMode: "eager" */ "/app/assets/policy/pic15.png");
;
import(/* webpackMode: "eager" */ "/app/assets/policy/pic16.png");
;
import(/* webpackMode: "eager" */ "/app/assets/policy/pic2.png");
;
import(/* webpackMode: "eager" */ "/app/assets/policy/pic3.png");
;
import(/* webpackMode: "eager" */ "/app/assets/policy/pic4.png");
;
import(/* webpackMode: "eager" */ "/app/assets/policy/pic5.png");
;
import(/* webpackMode: "eager" */ "/app/assets/policy/pic6.png");
;
import(/* webpackMode: "eager" */ "/app/assets/policy/pic7.png");
;
import(/* webpackMode: "eager" */ "/app/assets/policy/pic8.png");
;
import(/* webpackMode: "eager" */ "/app/assets/policy/pic9.png");
;
import(/* webpackMode: "eager" */ "/app/components/common/Footer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/common/Header/Layout/Default.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/common/Header/MobileMenu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/common/Link/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/containers/PolicyContainer/Styles.module.scss");
